import { ERROR, START, SUCCESS } from '../../../../constants/action-postfix'
import { APPLICANTS_REQUEST } from '../applicantsReducer'

const initialState = false

export const applicantsLoaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${APPLICANTS_REQUEST}${START}`:
      return true
    case `${APPLICANTS_REQUEST}${SUCCESS}`:
      return false
    case `${APPLICANTS_REQUEST}${ERROR}`:
      return false
    default:
      return state
  }
}
